import { Box, Typography, CircularProgress } from "@mui/material";
import { motion } from "framer-motion";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { colors, alphaVar } from "../../ui/colors";

export const JobLoadingStatus = ({ status = {} }) => {
  const steps = [
    {
      text: `Creating ${[status.first]}...`,
      icon: <AddTaskIcon sx={{ fontSize: 34, color: "#fff" }} />,
      gradient: `linear-gradient(135deg, ${colors.orange[400]}, ${colors.orange[600]})`,
    },
    {
      text: `Generating ${[status.second]}...`,
      icon: <WorkOutlineIcon sx={{ fontSize: 34, color: "#fff" }} />,
      gradient: `linear-gradient(135deg, ${colors.yellow[400]}, ${colors.orange[400]})`,
    },
    {
      text: `Calculating ${[status.three]}...`,
      icon: <TrendingUpIcon sx={{ fontSize: 34, color: "#fff" }} />,
      gradient: `linear-gradient(135deg, ${colors.success[400]}, ${colors.success[600]})`,
    },
  ];

  return (
    <Box
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        mt: 3,
        flexWrap: "wrap",
      }}
    >
      {steps.map((step, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ delay: i * 0.4, duration: 0.8 }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Box
            sx={{
              width: 70,
              height: 70,
              borderRadius: "50%",
              background: step.gradient,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: `0 6px 16px ${alphaVar(colors.gray[500], 0.2)}`,
            }}
          >
            {step.icon}
          </Box>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              color: colors.gray[700],
              letterSpacing: 0.3,
            }}
          >
            {step.text}
          </Typography>
        </motion.div>
      ))}

      {/* Spinner general al final */}
      <CircularProgress
        size={34}
        thickness={4}
        sx={{
          color: colors.orange.base,
          ml: 2,
        }}
      />
    </Box>
  );
};
